// IELTS Mock 5 — Academic Writing (bar chart + discuss-both-views essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK5_WRITING = {
  title: "Academic Writing Practice Test 5",
  tasks: [
    {
      id: "task1",
      mock: 5,
      title: "Task 1: Report (20 min)",
      prompt:
        "The bar graph compares the number of men and women in Britain who pursued further education in three different years, split by whether they studied full-time or part-time. Summarise the main trends by highlighting key details and making comparisons where needed.",
      image: "/images/ielts-mock5/task1_test1.avif",
      minWords: 150,
      keywords: ["men", "women", "male", "female", "further education", "full-time", "part-time", "britain", "1970", "1980", "1990", "thousand", "increas", "compar"],
      diagramType: "bar"
    },
    {
      id: "task2",
      mock: 5,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Some people think that schools should teach students how to become good citizens. Others believe that this should be the role of parents. Discuss both views and give your opinion.",
      minWords: 250,
      keywords: ["school", "parent", "citizen", "teach", "student", "children", "responsib", "society", "values", "community", "role", "opinion"]
    }
  ]
};

export default IELTS_MOCK5_WRITING;
